// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"de9a3afe9c33f950df16","453":"3934a841043687f56a61","522":"605bb4239dbedebae048"}[chunkId] + ".js";
};